import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mandatory-disclosure',
  templateUrl: './mandatory-disclosure.component.html',
  styleUrls: ['./mandatory-disclosure.component.scss']
})
export class MandatoryDisclosureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
